export default __webpack_public_path__ + "115f7c115104173bf10dae80eedbb8ed.png";